window.S = {
 "namn": "Noxhall",
 "retur": 14,
 "leverans": "7–15 dagar",
 "remsa": [
  "Fri frakt · Klarna · 14 dagars ångerrätt",
  "3 för 2 på alla smycken",
  "Höstrea −35 % på allt"
 ],
 "erbjudande": "Korthållare på köpet till varje väska",
 "sasong": "Höst 2026",
 "fottext": "Klockor, smycken och väskor. Få saker, noga utvalda.",
 "allaText": "Klockor, smycken, väskor och accessoarer. Fri frakt på allt.",
 "sokord": [
  "Klocka",
  "Rosa",
  "Armband",
  "Axelväska",
  "Shopper",
  "Svart"
 ],
 "reaord": "Höstrea",
 "tiktok": "DB43LKBC77UEHJIKBCK0",
 "kategorier": [
  {
   "id": "klockor",
   "namn": "Klockor",
   "text": "Rosa urtavlor, gnistrande stenar och länkar i stål. Klockor som syns på handleden."
  },
  {
   "id": "smycken",
   "namn": "Smycken",
   "text": "3 för 2 på alla smycken: köp 3, betala för 2. Det 3:e blir gratis."
  },
  {
   "id": "vaskor",
   "namn": "Väskor",
   "text": "Mjukt läder och rena former. Väskor att bära varje dag, i många år.",
   "under": [
    {
     "id": "axel",
     "namn": "Axelväskor"
    },
    {
     "id": "shopper",
     "namn": "Shoppers"
    },
    {
     "id": "liten",
     "namn": "Små väskor"
    }
   ]
  },
  {
   "id": "accessoarer",
   "namn": "Accessoarer",
   "text": "Korthållare, plånböcker och små saker i samma anda.",
   "under": [
    {
     "id": "kort",
     "namn": "Korthållare"
    },
    {
     "id": "planbok",
     "namn": "Plånböcker"
    }
   ]
  }
 ],
 "signatur": "rosalie",
 "gava": [
  "carte"
 ],
 "gerGava": [
  "vaskor"
 ],
 "gavor": [
  {
   "kat": "klockor",
   "gava": "solitaire",
   "till": "klocka",
   "namn": "armband",
   "valj": "Välj ditt armband på köpet",
   "erbjudande": "Armband på köpet till varje klocka",
   "rubrik": "Ett armband<br><em>på köpet</em>",
   "text": "Till varje klocka får du armbandet Lidingö utan kostnad. Det läggs i varukorgen automatiskt.",
   "knapp": "Välj din klocka"
  },
  {
   "kat": "vaskor",
   "gava": "carte",
   "till": "väska",
   "namn": "korthållare",
   "valj": "Välj din korthållare på köpet",
   "erbjudande": "Korthållare på köpet till varje väska",
   "rubrik": "En korthållare<br><em>på köpet</em>",
   "text": "Till varje väska får du en korthållare i läder utan kostnad. Du väljer färg i varukorgen.",
   "knapp": "Välj din väska"
  }
 ],
 "hero": [
  {
   "p": "rosalie",
   "b": "rosalie-2",
   "ljus": 1,
   "over": "Nyhet",
   "rubrik": "Den rosa klockan",
   "lank": "Se klockorna",
   "kat": "klockor"
  }
 ],
 "nyheter": [
  "celeste",
  "mira",
  "rive",
  "sable",
  "atelier",
  "jardin",
  "sadel",
  "korg"
 ],
 "accessoarer": [
  "carte",
  "pli",
  "champagne",
  "voyage",
  "bordeaux"
 ],
 "klockor": [
  "rosalie",
  "riviere",
  "opaline",
  "pivoine",
  "orbite",
  "solitaire"
 ],
 "par": [
  {
   "titel": "Céleste",
   "lank": "Upptäck Céleste",
   "p": "celeste",
   "b": "foto:hand-1"
  },
  {
   "titel": "Atelier",
   "lank": "Upptäck Atelier",
   "p": "atelier",
   "b": "foto:hand-2"
  }
 ],
 "produkter": [
  {
   "id": "celeste",
   "namn": "Céleste",
   "typ": "Axelväska med lock",
   "kat": "vaskor",
   "under": "axel",
   "pris": 695,
   "topp": 1,
   "farger": [
    [
     "karamell",
     "Karamell",
     "#8C4E2B"
    ],
    [
     "svart",
     "Svart",
     "#1A1918"
    ],
    [
     "gradd",
     "Gräddvit",
     "#ECE5D8"
    ],
    [
     "sand",
     "Sand",
     "#CDB18F"
    ],
    [
     "vin",
     "Vinröd",
     "#5E1B22"
    ]
   ],
   "kort": "Strukturerad väska med lock och ett litet guldfärgat lås. Klassisk på det sätt som aldrig blir omodernt.",
   "text": "Céleste har den ordning som en vardag behöver: en fast form, ett lock som stänger med ett litet guldfärgat lås och en smal rem som bärs kort på axeln. En väska som ser lika rätt ut på kontoret som på middagen.",
   "punkter": [
    "Äkta nötläder",
    "Lås i guldton",
    "Smal axelrem",
    "Foder i polyester"
   ],
   "matt": [
    [
     "Mått",
     "23 × 17 × 7 cm"
    ],
    [
     "Vikt",
     "ca 650 g"
    ],
    [
     "Material",
     "Äkta nötläder"
    ],
    [
     "Foder",
     "Polyester"
    ]
   ],
   "par": [
    "carte",
    "mira"
   ],
   "bilder": [
    "celeste",
    "celeste-2",
    "celeste-3"
   ],
   "fb": {
    "svart": [
     "celeste--svart",
     "celeste--svart-2"
    ],
    "gradd": [
     "celeste--gradd",
     "celeste--gradd-2"
    ],
    "sand": [
     "celeste--sand",
     "celeste--sand-2"
    ],
    "vin": [
     "celeste--vin",
     "celeste--vin-2"
    ]
   },
   "fore": 1070
  },
  {
   "id": "mira",
   "namn": "Mira",
   "typ": "Baguetteväska i läder",
   "kat": "vaskor",
   "under": "axel",
   "pris": 695,
   "topp": 1,
   "farger": [
    [
     "svart",
     "Svart",
     "#1A1918"
    ],
    [
     "vit",
     "Vit",
     "#F1EDE6"
    ]
   ],
   "kort": "En böjd baguette i blankt slätt läder som sitter tätt under armen.",
   "text": "Mira är formad efter kroppen: botten böjer sig mjukt och remmen är precis så lång att väskan sitter tätt under armen. Lädret är slätt med en mjuk lyster som fångar ljuset.",
   "punkter": [
    "Äkta nötläder",
    "Magnetlås",
    "Bärs under armen",
    "Foder i polyester"
   ],
   "matt": [
    [
     "Mått",
     "28 × 18 × 6 cm"
    ],
    [
     "Vikt",
     "ca 430 g"
    ],
    [
     "Material",
     "Äkta nötläder"
    ],
    [
     "Foder",
     "Polyester"
    ]
   ],
   "par": [
    "carte",
    "celeste"
   ],
   "bilder": [
    "mira",
    "mira-2"
   ],
   "fb": {
    "vit": [
     "mira--vit",
     "mira--vit-2"
    ]
   },
   "fore": 1070
  },
  {
   "id": "sable",
   "namn": "Sable",
   "typ": "Mjuk axelväska",
   "kat": "vaskor",
   "under": "axel",
   "pris": 595,
   "farger": [
    [
     "taupe",
     "Taupe",
     "#A8957B"
    ],
    [
     "svart",
     "Svart",
     "#1A1918"
    ],
    [
     "gradd",
     "Gräddvit",
     "#ECE5D8"
    ]
   ],
   "kort": "Slapp och mjuk, i narvat läder med en smal rullad rem. Väskan man tar varje morgon utan att tänka.",
   "text": "Sable är gjord för att leva i: mjukt narvat läder som faller ihop när du ställer ner den och formar sig när du bär den. Dragkedjan håller allt på plats och den rullade remmen är skön mot axeln.",
   "punkter": [
    "Äkta narvläder (toppnarv)",
    "Dragkedja upptill",
    "Rullad axelrem",
    "Foder i polyester"
   ],
   "matt": [
    [
     "Mått",
     "ca 28 × 18 × 6,5 cm"
    ],
    [
     "Material",
     "Äkta narvläder"
    ],
    [
     "Foder",
     "Polyester"
    ]
   ],
   "par": [
    "carte",
    "celeste"
   ],
   "bilder": [
    "sable",
    "sable-2"
   ],
   "fb": {
    "svart": [
     "sable--svart",
     "sable--svart-2"
    ],
    "gradd": [
     "sable--gradd",
     "sable--gradd-2"
    ]
   },
   "fore": 915
  },
  {
   "id": "rive",
   "namn": "Rive",
   "typ": "Mjuk shopper i läder",
   "kat": "vaskor",
   "under": "shopper",
   "pris": 995,
   "topp": 1,
   "farger": [
    [
     "konjak",
     "Konjak",
     "#9A5B2E"
    ],
    [
     "svart",
     "Svart",
     "#1A1918"
    ],
    [
     "choklad",
     "Choklad",
     "#3D2A21"
    ]
   ],
   "kort": "En mjuk, rymlig shopper i skrynklat läder med två handtag och en lång axelrem.",
   "text": "Rive tar det du behöver för en hel dag, och ser bättre ut ju mer den används. Lädret är mjukt och lätt skrynklat, handtagen bärs i handen eller i armvecket och den långa remmen gör den till en axelväska.",
   "punkter": [
    "Äkta narvläder (toppnarv)",
    "Två handtag och lång axelrem",
    "Rymmer en iPad",
    "Foder i bomullsblandning"
   ],
   "matt": [
    [
     "Mått",
     "32 × 22 × 13 cm"
    ],
    [
     "Vikt",
     "ca 600 g"
    ],
    [
     "Material",
     "Äkta narvläder"
    ],
    [
     "Foder",
     "Polyester/bomull"
    ]
   ],
   "par": [
    "carte"
   ],
   "bilder": [
    "rive",
    "rive-2",
    "rive-3"
   ],
   "fb": {
    "svart": [
     "rive--svart",
     "rive--svart-2"
    ],
    "choklad": [
     "rive--choklad",
     "rive--choklad-2"
    ]
   },
   "fore": 1530
  },
  {
   "id": "jardin",
   "namn": "Jardin",
   "typ": "Shopper med kontrastremmar",
   "kat": "vaskor",
   "under": "shopper",
   "pris": 895,
   "farger": [
    [
     "gradd",
     "Gräddvit",
     "#ECE5D8"
    ],
    [
     "gra",
     "Lavendelgrå",
     "#B3ADB6"
    ],
    [
     "karamell",
     "Karamell",
     "#8C4E2B"
    ],
    [
     "svart",
     "Svart",
     "#1A1918"
    ],
    [
     "duv",
     "Duvblå",
     "#93A9BE"
    ]
   ],
   "kort": "Strukturerad shopper i narvat läder med remmar i mörkt kontrastläder. Plats för dator och dag.",
   "text": "Jardin är arbetsväskan som inte ser ut som en. Den håller formen, stängs med dragkedja och har fack för telefon och kort, och de mörka remmarna gör de ljusa färgerna ännu ljusare.",
   "punkter": [
    "Äkta narvläder (toppnarv)",
    "Dragkedja och innerfack",
    "Remmar i kontrastläder",
    "Foder i bomullsblandning"
   ],
   "matt": [
    [
     "Material",
     "Äkta narvläder"
    ],
    [
     "Foder",
     "Polyester/bomull"
    ]
   ],
   "par": [
    "carte",
    "celeste"
   ],
   "bilder": [
    "jardin",
    "jardin-2"
   ],
   "fb": {
    "gra": [
     "jardin--gra",
     "jardin--gra-2"
    ],
    "karamell": [
     "jardin--karamell",
     "jardin--karamell-2"
    ],
    "svart": [
     "jardin--svart",
     "jardin--svart-2"
    ],
    "duv": [
     "jardin--duv",
     "jardin--duv-2"
    ]
   },
   "fore": 1375
  },
  {
   "id": "atelier",
   "namn": "Atelier",
   "typ": "Stor shopper i läder",
   "kat": "vaskor",
   "under": "shopper",
   "pris": 1095,
   "topp": 1,
   "farger": [
    [
     "mjolkte",
     "Mjölkte",
     "#C9B49A"
    ],
    [
     "svart",
     "Svart",
     "#1A1918"
    ],
    [
     "sand",
     "Sand",
     "#CDB18F"
    ]
   ],
   "kort": "Den stora öppna shoppern i slätt läder. Rymmer en hel dag och lite till.",
   "text": "Atelier är vardagsväskan i stort format: en rak shopper i slätt läder med två långa handtag, öppen upptill så att allt är nära till hands.",
   "punkter": [
    "Äkta nötläder",
    "Två långa handtag",
    "Rymmer en 13\" dator",
    "Foder i polyester"
   ],
   "matt": [
    [
     "Mått",
     "33 × 30 × 14 cm"
    ],
    [
     "Vikt",
     "ca 1 kg"
    ],
    [
     "Material",
     "Äkta nötläder"
    ],
    [
     "Foder",
     "Polyester"
    ]
   ],
   "par": [
    "carte",
    "rive"
   ],
   "bilder": [
    "atelier",
    "atelier-2"
   ],
   "fb": {
    "svart": [
     "atelier--svart",
     "atelier--svart-2"
    ],
    "sand": [
     "atelier--sand",
     "atelier--sand-2"
    ]
   },
   "fore": 1685
  },
  {
   "id": "carte",
   "namn": "Carte",
   "typ": "Korthållare i läder",
   "kat": "accessoarer",
   "under": "kort",
   "pris": 349,
   "topp": 1,
   "farger": [
    [
     "vin",
     "Vinröd",
     "#5E1B22"
    ],
    [
     "svart",
     "Svart",
     "#1A1918"
    ],
    [
     "gradd",
     "Gräddvit",
     "#ECE5D8"
    ],
    [
     "salvia",
     "Salvia",
     "#A9B2A5"
    ]
   ],
   "kort": "En tunn korthållare i narvat läder med tryckknapp. Får plats i minsta väskan.",
   "text": "Carte är korthållaren som ersätter plånboken: tunn, i mjukt narvat läder, med plats för de kort du faktiskt använder och en tryckknapp som håller allt på plats. Ingår utan kostnad när du köper en väska.",
   "punkter": [
    "Äkta narvläder (toppnarv)",
    "Tryckknapp",
    "Många kortfack",
    "På köpet till varje väska"
   ],
   "matt": [
    [
     "Mått",
     "10,8 × 9 × 0,7 cm"
    ],
    [
     "Material",
     "Äkta narvläder"
    ],
    [
     "Vikt",
     "ca 40 g"
    ]
   ],
   "par": [
    "celeste",
    "mira"
   ],
   "bilder": [
    "carte",
    "carte-2"
   ],
   "fb": {
    "svart": [
     "carte--svart",
     "carte--svart-2"
    ],
    "gradd": [
     "carte--gradd",
     "carte--gradd-2"
    ],
    "salvia": [
     "carte--salvia",
     "carte--salvia-2"
    ]
   },
   "fore": 535
  },
  {
   "id": "sadel",
   "namn": "Selle",
   "typ": "Axelväska med lock",
   "kat": "vaskor",
   "under": "axel",
   "pris": 595,
   "nytt": 1,
   "farger": [
    [
     "svart",
     "Svart",
     "#1A1918"
    ],
    [
     "konjak",
     "Konjak",
     "#9A5B2E"
    ]
   ],
   "kort": "En liten sadelväska i blankt läder med ett fyrkantigt spänne i guldton. Sitter över axeln eller tvärs över kroppen.",
   "text": "Selle har en mjukt rundad sadelform, ett lock som stänger med en ram i guldton och en smal rem som går att justera. Blankt, slätt läder som ser lika rent ut mot en kappa som mot en stickad tröja.",
   "punkter": [
    "Äkta nötläder",
    "Lås med ram i guldton",
    "Justerbar axelrem",
    "Dragkedja"
   ],
   "matt": [
    [
     "Mått",
     "20 × 16 × 6 cm"
    ],
    [
     "Vikt",
     "ca 510 g"
    ],
    [
     "Material",
     "Äkta nötläder"
    ],
    [
     "Foder",
     "Polyester"
    ]
   ],
   "par": [
    "carte",
    "mira"
   ],
   "bilder": [
    "sadel",
    "sadel-2"
   ],
   "fb": {
    "konjak": [
     "sadel--konjak",
     "sadel--konjak-2"
    ]
   },
   "fore": 915
  },
  {
   "id": "korg",
   "namn": "Panier",
   "typ": "Väska med knut i läder",
   "kat": "vaskor",
   "under": "axel",
   "pris": 695,
   "nytt": 1,
   "farger": [
    [
     "kamel",
     "Kamel",
     "#A8805F"
    ]
   ],
   "kort": "En mjuk hinkväska med ett enda brett handtag som knyts. Följer med som både handväska och axelväska.",
   "text": "Panier har ett brett handtag som knyts vid sidan, ett mjukt narvat läder som formar sig efter innehållet och en smal avtagbar rem. Rymlig nog för dagen, lätt att bära hela dagen.",
   "punkter": [
    "Äkta nötläder",
    "Brett handtag med knut",
    "Avtagbar axelrem",
    "Magnetstängning"
   ],
   "matt": [
    [
     "Mått",
     "23 × 14,5 × 20 cm"
    ],
    [
     "Vikt",
     "ca 620 g"
    ],
    [
     "Material",
     "Äkta nötläder"
    ],
    [
     "Foder",
     "Mikrofiber"
    ]
   ],
   "par": [
    "carte",
    "sable"
   ],
   "bilder": [
    "korg",
    "korg-2"
   ],
   "fore": 1070
  },
  {
   "id": "rosalie",
   "namn": "Strandvägen",
   "typ": "Damklocka med stenar",
   "kat": "klockor",
   "pris": 499,
   "topp": 1,
   "nytt": 1,
   "farger": [
    [
     "silver",
     "Silver",
     "#C5C7CA"
    ],
    [
     "guldvit",
     "Guld, vit urtavla",
     "#C9A45C"
    ]
   ],
   "kort": "Rektangulär klocka med en rad gnistrande stenar längs sidorna. I silverton med ljusrosa urtavla eller i guldton med krämvit urtavla.",
   "text": "Strandvägen är klockan man tittar på en gång till: romerska siffror och visare i guldton, en vit mittruta med strålmönster och liten sekundvisare, en rad små klara stenar längs boettens sidor, en blå sten i kronan och en länk i stål som ligger tätt mot handleden. Välj silverton med ljusrosa urtavla eller guldton med krämvit urtavla. Armbandet Lidingö följer med på köpet, så du har ett färdigt par från första dagen.",
   "punkter": [
    "Japanskt kvartsverk",
    "Romerska siffror i guldton",
    "Länk i rostfritt stål",
    "Mineralglas, tål stänk"
   ],
   "matt": [
    [
     "Boett",
     "20 × 30 mm, 8,4 mm tjock"
    ],
    [
     "Länk",
     "14 mm bred, rostfritt stål"
    ],
    [
     "Urverk",
     "Japanskt kvarts"
    ],
    [
     "Glas",
     "Mineralglas"
    ],
    [
     "Vattentät",
     "3 ATM (tål stänk)"
    ],
    [
     "Vikt",
     "ca 80 g"
    ]
   ],
   "par": [
    "solitaire"
   ],
   "bilder": [
    "rosalie",
    "rosalie-2"
   ],
   "fb": {
    "guldvit": [
     "rosalie--guldvit",
     "rosalie--guldvit-2"
    ]
   },
   "fore": 770
  },
  {
   "id": "opaline",
   "namn": "Djurgården",
   "typ": "Halsband med pärla",
   "kat": "smycken",
   "pris": 145,
   "nytt": 1,
   "kort": "En pansarkedja i guldton med en liten barockpärla i en hamrad infattning.",
   "text": "Djurgården är halsbandet man aldrig tar av sig: en pansarkedja i guldton och en sötvattenspärla med oregelbunden form, fattad i en mjukt hamrad ram.",
   "punkter": [
    "Sötvattenspärla",
    "Titanstål i guldton",
    "Hamrad infattning"
   ],
   "matt": [
    [
     "Material",
     "Titanstål i guldton, sötvattenspärla"
    ]
   ],
   "par": [
    "pivoine",
    "rosalie"
   ],
   "bilder": [
    "opaline"
   ],
   "fore": 225
  },
  {
   "id": "pivoine",
   "namn": "Nybroviken",
   "typ": "Pärlörhängen",
   "kat": "smycken",
   "pris": 145,
   "nytt": 1,
   "kort": "Små creoler i guldton med en rad klara stenar och en stor rund vit pärla direkt under.",
   "text": "Nybroviken är örhängena som gör ett vanligt plagg festligt: en liten creol i guldton med fyra klara stenar på rad och en stor rund vit pärla som sitter direkt under stenarna.",
   "punkter": [
    "Creol med fyra klara stenar",
    "Stor rund vit pärla",
    "Guldton"
   ],
   "matt": [
    [
     "Färg",
     "Guldton, vit pärla"
    ]
   ],
   "par": [
    "opaline",
    "solitaire"
   ],
   "bilder": [
    "pivoine"
   ],
   "fore": 225
  },
  {
   "id": "orbite",
   "namn": "Östermalm",
   "typ": "Creoler i silverton",
   "kat": "smycken",
   "pris": 145,
   "nytt": 1,
   "kort": "Släta, kraftiga creoler i polerad silverton. Tidlösa.",
   "text": "Östermalm är creolerna som passar till allt: släta, lite kraftiga ringar i polerad silverton som fångar ljuset utan att ta över.",
   "punkter": [
    "Polerad silverton",
    "Diameter ca 3 cm",
    "Nål i 999-silver"
   ],
   "matt": [
    [
     "Diameter",
     "ca 3 cm"
    ],
    [
     "Material",
     "Mässing i silverton, nål i 999-silver"
    ]
   ],
   "par": [
    "riviere"
   ],
   "bilder": [
    "orbite"
   ],
   "fore": 225
  },
  {
   "id": "solitaire",
   "namn": "Lidingö",
   "typ": "Armband med en sten",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "kort": "En tunn kedja i guldton med en enda klar sten. Minimalistiskt.",
   "text": "Lidingö är armbandet som syns precis lagom: en tunn kedja i guldton och en enda klar sten mitt på handleden. Fint ensamt eller bredvid en klocka.",
   "punkter": [
    "Klar sten i infattning",
    "Kedja i guldton",
    "Justerbar längd"
   ],
   "matt": [
    [
     "Sten",
     "ca 4 mm"
    ],
    [
     "Längd",
     "justerbar"
    ]
   ],
   "par": [
    "rosalie"
   ],
   "bilder": [
    "solitaire"
   ],
   "fore": 375
  },
  {
   "id": "pli",
   "namn": "Pli",
   "typ": "Kuvertplånbok",
   "kat": "accessoarer",
   "under": "planbok",
   "pris": 245,
   "nytt": 1,
   "kort": "En kuvertplånbok i narvat läder med en spetsig flik och en tryckknapp.",
   "text": "Pli är plånboken med en enda ren linje: en spetsig kuvertflik som stängs med en liten tryckknapp, i narvat läder med fack för kort och sedlar och ett fack med dragkedja inuti.",
   "punkter": [
    "Äkta nötläder",
    "Kuvertflik med tryckknapp",
    "Kortfack"
   ],
   "matt": [
    [
     "Mått",
     "19 × 10 × 2 cm"
    ],
    [
     "Vikt",
     "ca 150 g"
    ]
   ],
   "par": [
    "carte",
    "mira"
   ],
   "bilder": [
    "pli"
   ],
   "fore": 375
  },
  {
   "id": "champagne",
   "namn": "Champagne",
   "typ": "Sidenscarf",
   "kat": "accessoarer",
   "pris": 495,
   "nytt": 1,
   "kort": "En lång scarf i mullbärssilke med mjuk lyster. Om halsen, som sjal eller på väskan.",
   "text": "Champagne är scarfen som lyfter en kappa: mullbärssilke i satin med en mjuk lyster i ljust champagne. Knyt den om halsen, bär den som sjal eller knyt den runt väskans handtag.",
   "punkter": [
    "100 % mullbärssilke",
    "Satin med mjuk lyster",
    "175 × 55 cm"
   ],
   "matt": [
    [
     "Material",
     "100 % mullbärssilke"
    ],
    [
     "Mått",
     "175 × 55 cm"
    ]
   ],
   "par": [
    "rosalie",
    "opaline"
   ],
   "bilder": [
    "champagne"
   ],
   "fore": 760
  },
  {
   "id": "voyage",
   "namn": "Voyage",
   "typ": "Smyckesetui",
   "kat": "accessoarer",
   "pris": 245,
   "nytt": 1,
   "kort": "Ett resetui för smycken i två våningar, med dragkedjor, ringrullar och fack.",
   "text": "Voyage håller ordning på smyckena hemma och på resan: ett etui i två våningar med dragkedjor, ringrullar, fack för örhängen och plats för halsband.",
   "punkter": [
    "Konstläder med narvstruktur",
    "Två våningar med dragkedjor",
    "Ringrullar och fack"
   ],
   "matt": [
    [
     "Material",
     "Konstläder med narvstruktur"
    ],
    [
     "Utförande",
     "Två våningar"
    ]
   ],
   "par": [
    "opaline",
    "pivoine"
   ],
   "bilder": [
    "voyage"
   ],
   "fore": 375
  },
  {
   "id": "bordeaux",
   "namn": "Bordeaux",
   "typ": "Solglasögon",
   "kat": "accessoarer",
   "pris": 245,
   "nytt": 1,
   "kort": "Ovala cat-eye-solglasögon med blank vinröd båge och mörka polariserade glas.",
   "text": "Bordeaux har en mjukt uppdragen cat-eye-båge i blank vinröd TR90-plast och mörka polariserade glas med UV400-skydd.",
   "punkter": [
    "Båge i TR90-plast",
    "Polariserade glas, UV400",
    "Cat-eye-form"
   ],
   "matt": [
    [
     "Båge",
     "TR90"
    ],
    [
     "Glas",
     "Polariserade, UV400"
    ]
   ],
   "par": [
    "champagne"
   ],
   "bilder": [
    "bordeaux"
   ],
   "fore": 375
  },
  {
   "id": "ulriksdal",
   "namn": "Ulriksdal",
   "typ": "Damklocka med läderarmband",
   "kat": "klockor",
   "pris": 499,
   "topp": 1,
   "kort": "Rektangulär boett i silverton, romerska siffror och blå visare på svart läder.",
   "text": "Ulriksdal är en klassisk rektangulär klocka: en boett i silverton, en vit urtavla med romerska siffror, blå visare och en blå sten i kronan. Armbandet är i svart, präglat läder.",
   "punkter": [
    "Japanskt kvartsverk",
    "Armband i äkta läder",
    "Mineralglas",
    "Boett i zinklegering med silverton"
   ],
   "matt": [
    [
     "Boett",
     "27,7 × 28,4 mm, 7 mm tjock"
    ],
    [
     "Urverk",
     "Japanskt kvarts"
    ],
    [
     "Armband",
     "Äkta läder"
    ],
    [
     "Spänne",
     "Vikspänne i stål"
    ],
    [
     "Glas",
     "Mineralglas"
    ],
    [
     "Vattentät",
     "3 ATM (tål stänk)"
    ]
   ],
   "par": [
    "riviere",
    "celeste"
   ],
   "bilder": [
    "ulriksdal",
    "ulriksdal-2"
   ],
   "fore": 770
  },
  {
   "id": "riviere",
   "namn": "Saltsjöbaden",
   "typ": "Tennisarmband",
   "kat": "smycken",
   "pris": 445,
   "topp": 1,
   "kort": "Ett obrutet band av klara stenar i silverton. Armbandet som passar till allt.",
   "text": "Saltsjöbaden är tennisarmbandet i sin renaste form: en rad lika stora klara stenar i titanstål och ett lås som sitter säkert. Bärs ensamt eller bredvid klockan.",
   "punkter": [
    "Klara zirkonia",
    "Rostfritt titanstål",
    "Säkert lås"
   ],
   "matt": [
    [
     "Längd",
     "18 cm"
    ],
    [
     "Bredd",
     "4 mm"
    ],
    [
     "Material",
     "Titanstål och zirkonia"
    ]
   ],
   "par": [
    "ulriksdal"
   ],
   "bilder": [
    "riviere"
   ],
   "fore": 685
  },
  {
   "id": "gamlastan",
   "namn": "Gamla stan",
   "typ": "Halsband med hjärta",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "Ett litet blankt hjärta på en kulkedja i guldton.",
   "text": "Gamla stan är halsbandet man aldrig tar av sig: en tunn kedja med små guldkulor och ett mjukt, blankt hjärta i mitten. Titanstål som inte missfärgas.",
   "punkter": [
    "Titanstål i guldton",
    "Tål vatten och parfym",
    "Justerbar längd"
   ],
   "matt": [
    [
     "Material",
     "Titanstål"
    ],
    [
     "Längd",
     "ca 40 + 5 cm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "gamlastan"
   ],
   "fore": 375
  },
  {
   "id": "vasastan",
   "namn": "Vasastan",
   "typ": "Halsband med pärlor",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "En Y-kedja i guldton med två vita pärlor.",
   "text": "Vasastan är ett Y-halsband: en liten pärla där kedjorna möts och en större pärla längst ner på en fin droppkedja. Elegant till både skjorta och stickat.",
   "punkter": [
    "Titanstål i guldton",
    "Två pärlor",
    "Justerbar längd"
   ],
   "matt": [
    [
     "Material",
     "Titanstål, konstpärlor"
    ],
    [
     "Längd",
     "ca 40 + 5 cm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "vasastan"
   ],
   "fore": 375
  },
  {
   "id": "kungsholmen",
   "namn": "Kungsholmen",
   "typ": "Halsband med pärla",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "Två tunna böjda stavar i guldton som håller en liten pärla.",
   "text": "Kungsholmen är ett stilrent halsband: två slanka, böjda stavar i guldton som korsas och håller en liten vit pärla. Sitter fint precis under nyckelbenet.",
   "punkter": [
    "Titanstål i guldton",
    "Liten pärla",
    "Justerbar längd"
   ],
   "matt": [
    [
     "Material",
     "Titanstål, konstpärla"
    ],
    [
     "Längd",
     "ca 40 + 5 cm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "kungsholmen"
   ],
   "fore": 375
  },
  {
   "id": "norrmalm",
   "namn": "Norrmalm",
   "typ": "Halsband med sten",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "silver",
     "Silver",
     "#C5C7CA"
    ]
   ],
   "kort": "En klar sten i fyra klor på en fin kedja i silverton.",
   "text": "Norrmalm är ett klassiskt halsband: en enda klar sten i en fyrklo-infattning på en fin kedja i silverton. Glittrar utan att ta över.",
   "punkter": [
    "Titanstål i silverton",
    "Klar zirkonia",
    "Justerbar längd"
   ],
   "matt": [
    [
     "Material",
     "Titanstål, zirkonia"
    ],
    [
     "Längd",
     "ca 40 + 5 cm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "norrmalm"
   ],
   "fore": 375
  },
  {
   "id": "gardet",
   "namn": "Gärdet",
   "typ": "Halsband med rund sten",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "En liten rund sten i infattning på tunn kedja i guldton.",
   "text": "Gärdet är det minsta halsbandet i butiken: en liten klar sten i en rund infattning i guldton på en tunn kedja. Perfekt att bära varje dag.",
   "punkter": [
    "Titanstål i guldton",
    "Klar zirkonia",
    "Justerbar längd"
   ],
   "matt": [
    [
     "Material",
     "Titanstål, zirkonia"
    ],
    [
     "Längd",
     "ca 40 + 5 cm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "gardet"
   ],
   "fore": 375
  },
  {
   "id": "humlegarden",
   "namn": "Humlegården",
   "typ": "Armband med hjärtan",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "En supertunn kedja i guldton med tre små hjärtan.",
   "text": "Humlegården är ett fint armband med tre små hjärtan på en supertunn kedja i guldton. Bär det ensamt eller tillsammans med halsbandet Gamla stan.",
   "punkter": [
    "Titanstål i guldton",
    "Tre små hjärtan",
    "Förlängningskedja"
   ],
   "matt": [
    [
     "Material",
     "Titanstål"
    ],
    [
     "Längd",
     "ca 16 + 5 cm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "humlegarden"
   ],
   "fore": 375
  },
  {
   "id": "mariatorget",
   "namn": "Mariatorget",
   "typ": "Pärlarmband",
   "kat": "smycken",
   "pris": 295,
   "nytt": 1,
   "farger": [
    [
     "silver",
     "Silver",
     "#C5C7CA"
    ]
   ],
   "kort": "Vita pärlor och glittrande kulor i silverton.",
   "text": "Mariatorget är ett pärlarmband med runda vita pärlor och små glittrande kulor i silverton emellan. Klassiskt med en liten twist.",
   "punkter": [
    "Konstpärlor",
    "Glittrande kulor i silverton",
    "Förlängningskedja"
   ],
   "matt": [
    [
     "Material",
     "Titanstål, konstpärlor"
    ],
    [
     "Längd",
     "ca 16 + 5 cm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "mariatorget"
   ],
   "fore": 455
  },
  {
   "id": "riddarholmen",
   "namn": "Riddarholmen",
   "typ": "Dubbelt pärlarmband",
   "kat": "smycken",
   "pris": 295,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "Två fina kedjor med pärlor och stenar och en liten blomma.",
   "text": "Riddarholmen är ett dubbelt armband i guldton: en kedja med små pärlor och en med klara stenar, förenade av en liten glittrande blomma.",
   "punkter": [
    "Titanstål i guldton",
    "Pärlor och zirkonia",
    "Förlängningskedja"
   ],
   "matt": [
    [
     "Material",
     "Titanstål, konstpärlor, zirkonia"
    ],
    [
     "Längd",
     "ca 16 + 5 cm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "riddarholmen"
   ],
   "fore": 455
  },
  {
   "id": "sandhamn",
   "namn": "Sandhamn",
   "typ": "Tennisarmband i guldton",
   "kat": "smycken",
   "pris": 495,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "Ett obrutet band av klara stenar i guldton.",
   "text": "Sandhamn är tennisarmbandet i guldton: en rad lika stora klara stenar i rostfritt stål och ett säkert lås. Passar lika bra till jeans som till fest.",
   "punkter": [
    "Rostfritt stål i guldton",
    "Klara zirkonia",
    "Säkert lås"
   ],
   "matt": [
    [
     "Material",
     "Rostfritt stål, zirkonia"
    ],
    [
     "Längd",
     "ca 18 cm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "sandhamn"
   ],
   "fore": 760
  },
  {
   "id": "birkastan",
   "namn": "Birkastan",
   "typ": "Tunn ring med stenar",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "opt2": {
    "namn": "Storlek",
    "val": [
     [
      "us6",
      "16,5 mm",
      null
     ],
     [
      "us7",
      "17,3 mm",
      null
     ],
     [
      "us8",
      "18,2 mm",
      null
     ],
     [
      "us9",
      "19 mm",
      null
     ]
    ]
   },
   "kort": "En supertunn ring i guldton med tre små stenar.",
   "text": "Birkastan är en supertunn ring i guldton med tre små klara stenar på rad. Fin ensam eller staplad med fler ringar.",
   "punkter": [
    "Titanstål i guldton",
    "Tre små zirkonia",
    "Supertunn"
   ],
   "matt": [
    [
     "Material",
     "Titanstål, zirkonia"
    ],
    [
     "Storlek",
     "Innerdiameter 16,5–19 mm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "birkastan"
   ],
   "fore": 375
  },
  {
   "id": "danderyd",
   "namn": "Danderyd",
   "typ": "Ring med sten",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "opt2": {
    "namn": "Storlek",
    "val": [
     [
      "us5",
      "15,7 mm",
      null
     ],
     [
      "us6",
      "16,5 mm",
      null
     ],
     [
      "us7",
      "17,3 mm",
      null
     ],
     [
      "us8",
      "18,2 mm",
      null
     ],
     [
      "us9",
      "19 mm",
      null
     ],
     [
      "us10",
      "19,8 mm",
      null
     ]
    ]
   },
   "kort": "En klar sten i fyra klor med små stenar längs ringen.",
   "text": "Danderyd är en ring i guldton med en klar sten i fyra klor och små stenar längs sidorna. En klassisk form som glittrar.",
   "punkter": [
    "Titanstål i guldton",
    "Klar zirkonia",
    "Stenar längs ringen"
   ],
   "matt": [
    [
     "Material",
     "Titanstål, zirkonia"
    ],
    [
     "Storlek",
     "Innerdiameter 15,7–19,8 mm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "danderyd"
   ],
   "fore": 375
  },
  {
   "id": "soder",
   "namn": "Söder",
   "typ": "Ring med pärlor",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "En öppen ring med en rad pärlor och en rad stenar.",
   "text": "Söder är en öppen ring i guldton där en rad små pärlor och en rad klara stenar går om varandra. Justerbar, så den passar de flesta.",
   "punkter": [
    "Guldton",
    "Pärlor och zirkonia",
    "Justerbar storlek"
   ],
   "matt": [
    [
     "Material",
     "Legering, konstpärlor, zirkonia"
    ],
    [
     "Storlek",
     "Justerbar"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "soder"
   ],
   "fore": 375
  },
  {
   "id": "hornstull",
   "namn": "Hornstull",
   "typ": "Ringörhängen",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "Blanka ringörhängen i guldton, ca 4 cm.",
   "text": "Hornstull är de släta ringörhängena alla behöver: blanka, lätta och lite tjockare nertill. Rostfritt stål 316 som tål vardagen.",
   "punkter": [
    "Rostfritt stål 316",
    "Ca 4 cm i diameter",
    "Lätta att bära"
   ],
   "matt": [
    [
     "Material",
     "Rostfritt stål 316"
    ],
    [
     "Storlek",
     "ca 4 cm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "hornstull"
   ],
   "fore": 375
  },
  {
   "id": "tyreso",
   "namn": "Tyresö",
   "typ": "Örhängen med rosett",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "En liten krans av pärlor och stenar med en rosett i guldton.",
   "text": "Tyresö är små örhängen formade som en krans av vita pärlor och klara stenar, med en liten rosett i guldton överst.",
   "punkter": [
    "Guldton",
    "Pärlor och zirkonia",
    "Nål i 925-silver"
   ],
   "matt": [
    [
     "Material",
     "Legering, konstpärlor, zirkonia, nål i 925-silver"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "tyreso"
   ],
   "fore": 375
  },
  {
   "id": "solna",
   "namn": "Solna",
   "typ": "Örhängen med pärla",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "En droppformad ram i guldton med en pärla i botten.",
   "text": "Solna är örhängen med en öppen droppformad ram i guldton och en rund vit pärla som vilar i botten. Enkla och eleganta.",
   "punkter": [
    "Guldton",
    "Rund pärla",
    "Nål i 925-silver"
   ],
   "matt": [
    [
     "Material",
     "Legering, konstpärla, nål i 925-silver"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "solna"
   ],
   "fore": 375
  },
  {
   "id": "kungstradgarden",
   "namn": "Kungsträdgården",
   "typ": "Pärlörhängen",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "En rund pärla på en krok i guldton.",
   "text": "Kungsträdgården är klassiska pärlörhängen: en rund vit pärla på en enkel krok i guldton. Passar till allt.",
   "punkter": [
    "Krok i 925-silver",
    "Pärla ca 10 mm",
    "Guldton"
   ],
   "matt": [
    [
     "Material",
     "925-silver, konstpärla"
    ],
    [
     "Pärla",
     "ca 10 mm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "kungstradgarden"
   ],
   "fore": 375
  },
  {
   "id": "hammarby",
   "namn": "Hammarby",
   "typ": "Ringörhängen med pärlor",
   "kat": "smycken",
   "pris": 295,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "Små vridna ringar i guldton med pärlor.",
   "text": "Hammarby är små ringörhängen i guldton med en vriden form som är täckt av små vita pärlor. Snäpplås som sitter säkert.",
   "punkter": [
    "Guldpläterad mässing",
    "Små pärlor",
    "Snäpplås"
   ],
   "matt": [
    [
     "Material",
     "Mässing, konstpärlor"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "hammarby"
   ],
   "fore": 455
  },
  {
   "id": "vaxholm",
   "namn": "Vaxholm",
   "typ": "Solitärring",
   "kat": "smycken",
   "pris": 245,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ],
    [
     "silver",
     "Silver",
     "#C5C7CA"
    ]
   ],
   "opt2": {
    "namn": "Storlek",
    "val": [
     [
      "us5",
      "15,7 mm",
      null
     ],
     [
      "us6",
      "16,5 mm",
      null
     ],
     [
      "us7",
      "17,3 mm",
      null
     ],
     [
      "us8",
      "18,2 mm",
      null
     ],
     [
      "us9",
      "19 mm",
      null
     ],
     [
      "us10",
      "19,8 mm",
      null
     ]
    ]
   },
   "kort": "En stor klar sten i sex klor på en slät ring.",
   "text": "Vaxholm är en klassisk solitärring: en stor rund klar sten i sex klor på en slät och blank ring. Enkel och elegant, fin ensam eller staplad.",
   "punkter": [
    "Titanstål",
    "Stor klar zirkonia",
    "Sex klor"
   ],
   "matt": [
    [
     "Material",
     "Titanstål, zirkonia"
    ],
    [
     "Storlek",
     "Innerdiameter 15,7–19,8 mm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "vaxholm"
   ],
   "fb": {
    "silver": [
     "vaxholm--silver"
    ]
   },
   "fore": 375
  },
  {
   "id": "ljustero",
   "namn": "Ljusterö",
   "typ": "Pärlörhängen",
   "kat": "smycken",
   "pris": 295,
   "nytt": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "En stor pärla under en liten ring med klara stenar.",
   "text": "Ljusterö är örhängen med en stor rund vit pärla som hänger under en liten ring i guldton täckt av klara stenar. Snäpplås som sitter säkert.",
   "punkter": [
    "Pärla ca 16 mm",
    "Ring med klara stenar",
    "Snäpplås"
   ],
   "matt": [
    [
     "Material",
     "Mässing, zirkonia, konstpärla"
    ],
    [
     "Pärla",
     "ca 16 mm"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "ljustero"
   ],
   "fore": 455
  }
 ],
 "utkast": [
  {
   "id": "lune",
   "namn": "Lune",
   "typ": "Axelväska i läder",
   "kat": "vaskor",
   "under": "axel",
   "pris": 795,
   "topp": 1,
   "nytt": 1,
   "utkast": 1,
   "farger": [
    [
     "konjak",
     "Konjak",
     "#9A5B2E"
    ],
    [
     "svart",
     "Svart",
     "#1A1918"
    ],
    [
     "choklad",
     "Choklad",
     "#3D2A21"
    ]
   ],
   "kort": "En mjuk droppformad väska i äkta läder med kort axelrem. Sitter tätt under armen.",
   "text": "Lune är en ren droppform utan onödiga detaljer, i slätt äkta läder. Den korta remmen gör att väskan sitter tätt under armen. Den rymmer telefon, plånbok och nycklar.",
   "punkter": [
    "Äkta nötläder",
    "Kort axelrem",
    "Ring i mörk silverton",
    "Foder i polyester"
   ],
   "matt": [
    [
     "Mått",
     "30 × 24 × 8 cm"
    ],
    [
     "Vikt",
     "ca 570 g"
    ],
    [
     "Material",
     "Äkta nötläder"
    ],
    [
     "Foder",
     "Polyester"
    ]
   ],
   "par": [
    "carte",
    "mira"
   ],
   "bilder": [
    "lune",
    "lune-2"
   ],
   "fb": {
    "svart": [
     "lune--svart",
     "lune--svart-2"
    ],
    "choklad": [
     "lune--choklad",
     "lune--choklad-2"
    ]
   },
   "fore": 1225
  },
  {
   "id": "bagu",
   "namn": "Opéra",
   "typ": "Baguetteväska i läder",
   "kat": "vaskor",
   "under": "axel",
   "pris": 545,
   "nytt": 1,
   "utkast": 1,
   "farger": [
    [
     "svart",
     "Svart",
     "#1A1918"
    ],
    [
     "konjak",
     "Konjak",
     "#9A5B2E"
    ]
   ],
   "kort": "En smal baguette i blankt läder med ett litet lås i guldton. Sitter tätt under armen.",
   "text": "Opéra är den smala väskan till det mesta: blankt slätt läder, ett lock som stänger med ett litet vridlås i guldton och en smal läderrem som håller väskan tätt under armen. Rymmer telefon, kort och läppstift.",
   "punkter": [
    "Äkta nötläder",
    "Vridlås i guldton",
    "Smal axelrem i läder",
    "Foder i polyester"
   ],
   "matt": [
    [
     "Mått",
     "26 × 12 × 5 cm"
    ],
    [
     "Vikt",
     "ca 410 g"
    ],
    [
     "Material",
     "Äkta nötläder"
    ],
    [
     "Foder",
     "Polyester"
    ]
   ],
   "par": [
    "carte"
   ],
   "bilder": [
    "bagu",
    "bagu-2"
   ],
   "fb": {
    "konjak": [
     "bagu--konjak",
     "bagu--konjak-2"
    ]
   },
   "fore": 840
  },
  {
   "id": "aurelie",
   "namn": "Drottningholm",
   "typ": "Liten damklocka i guldton",
   "kat": "klockor",
   "pris": 399,
   "nytt": 1,
   "utkast": 1,
   "farger": [
    [
     "guld",
     "Guld",
     "#C9A45C"
    ]
   ],
   "kort": "En liten åttkantig klocka med rosa urtavla och två små stenar, på en fin ledad länk. Diskret och vintage.",
   "text": "Drottningholm är den lilla klockan som känns ärvd: en åttkantig boett i guldton med facetterad kant, en rosa urtavla med strålmönster, två små klara stenar vid 12 och 6, streck i guldton vid 3 och 9, en blå sten i kronan och en smal ledad länk i guldton som ligger mjukt runt handleden.",
   "punkter": [
    "Japanskt kvartsverk",
    "Rosa urtavla med två stenar",
    "Länk i rostfritt stål",
    "Mineralglas, tål stänk"
   ],
   "matt": [
    [
     "Boett",
     "18 × 23 mm, 8,5 mm tjock"
    ],
    [
     "Länk",
     "8 mm bred, rostfritt stål"
    ],
    [
     "Urverk",
     "Japanskt kvarts"
    ],
    [
     "Glas",
     "Mineralglas"
    ],
    [
     "Vattentät",
     "3 ATM (tål stänk)"
    ],
    [
     "Vikt",
     "ca 80 g"
    ]
   ],
   "par": [
    "rosalie",
    "riviere"
   ],
   "bilder": [
    "aurelie",
    "aurelie-2"
   ],
   "fore": 615
  },
  {
   "id": "carre",
   "namn": "Karlaplan",
   "typ": "Fyrkantig damklocka i silverton",
   "kat": "klockor",
   "pris": 399,
   "nytt": 1,
   "utkast": 1,
   "farger": [
    [
     "silver",
     "Silver",
     "#C5C7CA"
    ]
   ],
   "kort": "En fyrkantig klocka med pärlemorurtavla och fyra små stenar, på en bred randig länk i stål. Modern och ren.",
   "text": "Karlaplan är klockan utan krusiduller: en fyrkantig boett, en urtavla i pärlemor utan siffror med fyra små klara stenar vid 12, 3, 6 och 9, och en bred randig länk i stål som går rakt ut från boetten.",
   "punkter": [
    "Japanskt kvartsverk",
    "Urtavla i pärlemor med fyra stenar",
    "Länk i rostfritt stål",
    "Mineralglas, tål stänk"
   ],
   "matt": [
    [
     "Boett",
     "19,5 × 18 mm, 7,5 mm tjock"
    ],
    [
     "Länk",
     "Rostfritt stål"
    ],
    [
     "Urverk",
     "Japanskt kvarts"
    ],
    [
     "Glas",
     "Mineralglas"
    ],
    [
     "Vattentät",
     "3 ATM (tål stänk)"
    ]
   ],
   "par": [
    "rosalie",
    "orbite"
   ],
   "bilder": [
    "carre",
    "carre-2"
   ],
   "fore": 615
  },
  {
   "id": "baiser",
   "namn": "Baiser",
   "typ": "Liten plånbok med bygel",
   "kat": "accessoarer",
   "under": "planbok",
   "pris": 295,
   "nytt": 1,
   "utkast": 1,
   "kort": "En liten plånbok i narvat läder med en myntficka med bygel på framsidan. Kortfack och sedelfack inuti.",
   "text": "Baiser är en liten plånbok i äkta narvat nötläder med en myntficka med bygel på framsidan. Inuti finns kortfack, sedelfack och ID-ficka, och den har RFID-skydd.",
   "punkter": [
    "Äkta nötläder",
    "Myntficka med bygel i ljus guldton",
    "Kortfack och RFID-skydd"
   ],
   "matt": [
    [
     "Mått",
     "ca 11 × 9 × 4 cm"
    ],
    [
     "Material",
     "Äkta nötläder"
    ],
    [
     "Vikt",
     "ca 130 g"
    ]
   ],
   "par": [
    "carte",
    "pli"
   ],
   "bilder": [
    "baiser"
   ],
   "fore": 455
  }
 ]
};
